import React, { forwardRef } from 'react'
import { MuiTelInputProps } from 'mui-tel-input'
import { MuiTelInputStyled } from './styles'
import { matchIsValidTel } from 'mui-tel-input'

const TelInput = forwardRef<HTMLDivElement, MuiTelInputProps>((props, ref) => {
  return <MuiTelInputStyled ref={ref} {...props} />
})

TelInput.displayName = 'TelInput'

export { TelInput, matchIsValidTel }
export type { MuiTelInputProps }